$(document).ready(function () {
  const counterUp = window.counterUp['default'];

  const counterNumberOfInvestors = document.getElementById('counterNumberOfInvestors');
  if (counterNumberOfInvestors) {
    counterUp(counterNumberOfInvestors, { delay: 60, duration: 1700 });
  }

  const counterAverageReturn = document.getElementById('counterAverageReturn');
  if (counterAverageReturn) {
    counterUp(counterAverageReturn, { delay: 60, duration: 1000 });
  }

  const counterInsolvabilityRate = document.getElementById('counterInsolvabilityRate');
  if (counterInsolvabilityRate) {
    counterUp(counterInsolvabilityRate, { delay: 60, duration: 1300 });
  }

  const counterFundedBy = document.getElementById('counterFundedBy');
  if (counterFundedBy) {
    counterUp(counterFundedBy, { delay: 60, duration: 1600 });
  }
});
